import { Box, Chip, Grid, Typography, styled } from "@mui/material"
import ImageComponent from "../../../components/inputs/ImageComponent"
import moment from "moment"
import { findObjectKeyByValue } from "../../../utils/helper"
import { DRUM, GENDER, WAX } from "../../../utils/constants"
import FileDownloadComponent from "../../../components/FileDownloadComponent"
import { BENIFICIARY_STATUS, HAS_HEARING_LOSS, HEARING_STATE, INCLUSION_STATE, SEVEARITY_OF_LOSS, SPEECH_STATE, TYPE_OF_HEARING_LOSS, WAY_OF_CONFIRMATION } from "../../../utils/beneficiary.constant"
import { Cancel, Check } from "@mui/icons-material"
// import { display } from "html2canvas/dist/types/css/property-descriptors/display"

const Header = styled(Box)(({ theme }) => ({
    border: '1px solid ' + theme.palette.primary.main,
    padding: theme.spacing(2),
    background: theme.palette.secondary.main,
    borderTopLeftRadius: theme.shape.borderRadius * 2,
    borderBottom: "0px",
    borderTopRightRadius: theme.shape.borderRadius * 2,
    width: "100%"
}))
const Body = styled(Box)(({ theme }) => ({
    border: '1px solid ' + theme.palette.primary.main,
    padding: theme.spacing(2),

    marginBottom: theme.spacing(2),

    borderBottomLeftRadius: theme.shape.borderRadius * 2,
    borderBottomRightRadius: theme.shape.borderRadius * 2,
    width: "100%"
}))
const HearingDetails = ({ data }) => {
    console.log("object dataaa", data);
    return <>
        {/* 
        <Header>
            <Typography fontWeight="bold" variant="body1">
                Current Progress
            </Typography>
        </Header>
        <Body>
            <Grid container spacing={2}>
                <Grid item md={3} xs={6} >
                    <Typography fontWeight="bold" variant="body2">Hearing:</Typography>

                </Grid>
                <Grid item md={3} xs={6} >
                    <Typography variant="body2">{data.hearing_state ? findObjectKeyByValue(data.hearing_state, HEARING_STATE) : "NA"}</Typography>
                </Grid>



                <Grid item md={3} xs={6} >
                    <Typography fontWeight="bold" variant="body2">Speech:</Typography>
                </Grid>
                <Grid item md={3} xs={6} >
                    <Typography variant="body2">{data.speech_state ? findObjectKeyByValue(data.speech_state, SPEECH_STATE) : "NA"}</Typography>
                </Grid>


                {data.inclusion_state && <>

                    <Grid item md={3} xs={6} >
                        <Typography fontWeight="bold" variant="body2">Inclusion Level:</Typography>
                    </Grid>
                    <Grid item md={3} xs={6} >
                        <Typography variant="body2">{data.inclusion_state ? findObjectKeyByValue(data.inclusion_state, INCLUSION_STATE) : "NA"}</Typography>
                    </Grid>

                </>}

            </Grid>
        </Body> */}



        <Header>
            <Typography fontWeight="bold" variant="body1">
                Otoscope Details
            </Typography>
        </Header>
        <Body>

            <Grid container md={12} spacing={2}>
                <Grid item md={6} xs={12} >
                    <Grid container spacing={2}>
                        <Grid item md={4} xs={6} >
                            <Typography fontWeight="bold" variant="body2">Right Ear Wax :</Typography>
                        </Grid>
                        <Grid item md={8} xs={6} >
                            <Typography variant="body2">{data.right_ear_wax ? findObjectKeyByValue(data.right_ear_wax, WAX) : "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} mb={1}>
                        <Grid item md={4} xs={6} >
                            <Typography fontWeight="bold" variant="body2">Right Ear Drum :</Typography>
                        </Grid>
                        <Grid item md={8} xs={6} >
                            <Typography variant="body2">{findObjectKeyByValue(data.right_eardrum, DRUM) ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    {data?.right_eardrum == DRUM.PERFORATED && <Grid container spacing={2} mb={1}>
                        <Grid item md={4} xs={6} >
                            <Typography fontWeight="bold" variant="body2">Right Ear Perforated Type Active :</Typography>
                        </Grid>
                        <Grid item md={8} xs={6} >
                            <Typography variant="body2">{data.is_discharge_right ?? "NA"}</Typography>
                        </Grid>
                    </Grid>}
                </Grid>

                <Grid item md={6} xs={12} >
                    <Grid container spacing={2}>
                        <Grid item md={4} xs={6} >
                            <Typography fontWeight="bold" variant="body2">Left Ear Wax :</Typography>
                        </Grid>
                        <Grid item md={8} xs={6} >
                            <Typography variant="body2">{data.left_ear_wax ? findObjectKeyByValue(data.left_ear_wax, WAX) : "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} mb={1}>
                        <Grid item md={4} xs={6} >
                            <Typography fontWeight="bold" variant="body2">Left Ear Drum :</Typography>
                        </Grid>
                        <Grid item md={8} xs={6} >
                            <Typography variant="body2">{findObjectKeyByValue(data.left_eardrum, DRUM) ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    {data?.left_eardrum == DRUM.PERFORATED && <Grid container spacing={2} mb={1}>
                        <Grid item md={4} xs={6} >
                            <Typography fontWeight="bold" variant="body2">Left Ear Perforated Type Active :</Typography>
                        </Grid>
                        <Grid item md={8} xs={6} >
                            <Typography variant="body2">{data.is_discharge_left ?? "NA"}</Typography>
                        </Grid>
                    </Grid>}
                </Grid>
            </Grid>
        </Body>
        {/* <Box sx={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
                <Header>
                    <Typography fontWeight="bold" variant="body1">
                        Left Response Details
                    </Typography>
                </Header>
                <Body>

                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">250 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.left_250 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">500 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.left_500 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">1000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.left_1000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">2000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.left_2000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">4000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.left_4000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">8000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.left_8000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                </Body>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
                <Header>
                    <Typography fontWeight="bold" variant="body1">
                        Right Response Details
                    </Typography>
                </Header>
                <Body>

                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">250 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.right_250 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">500 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.right_500 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">1000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.right_1000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">2000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.right_2000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">4000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.right_4000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={6} >
                            <Typography fontWeight="bold" variant="body2">8000 HZ :</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} >
                            <Typography variant="body2">{data.right_8000 ?? "NA"}</Typography>
                        </Grid>
                    </Grid>
                </Body>
            </Box>
        </Box> */}
    </>
}
export default HearingDetails